import React, { Component } from "react";
import { connect } from "react-redux";
import {
  selectLoggedAs,
  selectCurrentNavPage,
  selectCurrentOrganization,
  selectUserOrganizations
} from "Selectors";
import { setCurrentOrganization } from "Thunks";
import { push } from "react-router-redux";
import MenuContent from "./MenuContent";

export class Menu extends Component {
  handleRedirectTo = to => {
    this.props.dispatch(push(to));
  };

  handleSetCurrentOrganization = organization => {
    this.props
      .dispatch(setCurrentOrganization(organization))
      .then(() => this.props.dispatch(push("/")));
    // browserHistory.push("/");
    // todo need improvement, This a hack i.e setCurrentOrganization now make an async call before updating current org in the store
    // OrganisationSelect Component use Navlink which directly redirect to "/"
    // setTimeout(() => this.props.dispatch(push("/")), 500);
  };

  render() {
    const { auth } = this.props;
    if (this.props.notConnectedAccess) {
      return null;
    }
    const { preferences } = auth;
    let allowAccessToSettings =
      preferences && preferences.allowAccessToSettings === "1";
    return (
      <MenuContent
        {...this.props}
        allowAccessToSettings={allowAccessToSettings}
        handleRedirectTo={this.handleRedirectTo}
        handleSetCurrentOrganization={this.handleSetCurrentOrganization}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth,
  loggedAs: selectLoggedAs(state),
  user: state.auth.user,
  notifications: state.auth.notifications,
  token: state.auth.token,
  embedded: state.params.embedded,
  userOrganizations: selectUserOrganizations(state),
  currentOrganization: selectCurrentOrganization(state),
  currentNavPage: selectCurrentNavPage(state),
  lng: state.params.lng,
  appsState:
    state.auth.currentOrganization && state.auth.currentOrganization.appsState,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/index.js